import { Box, Stack, Typography } from '@mui/material';
import { Diagnostic } from 'vscode-languageserver-protocol';
import type { Range } from 'vscode-languageserver-types';
import ProblemIcon from './ProblemIcon';

const ProblemItem = (props: { index: number; diagnostic: Diagnostic; onSelectRange: (range: Range) => void }) => {
  return (
    <Box
      sx={{
        ...styles.diagnosticContainer,
        backgroundColor: props.index % 2 === 0 ? 'spheroGrey.diagnostic' : 'background.paper',
      }}
      onClick={() => props.onSelectRange(props.diagnostic.range)}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <ProblemIcon severity={props.diagnostic.severity} />
        <Typography>{`Line ${props.diagnostic.range.end.line + 1}:`}</Typography>
        <Typography>{props.diagnostic.message}</Typography>
        {props.diagnostic.code ? <Typography sx={styles.diagnosticSourceText}>{`  (${props.diagnostic.code})`}</Typography> : undefined}
      </Stack>
    </Box>
  );
};

const styles = {
  diagnosticContainer: {
    width: '100%',
    alignItems: 'left',
    justifyContent: 'left',
    color: 'text.primary',
    '&:hover': {
      backgroundColor: 'action.hover',
    },
  },
  diagnosticSourceText: {
    color: 'text.secondary',
  },
};

export default ProblemItem;
